import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Card, CardBody, FormGroup, Input,
  Badge, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap'
import { Editor } from 'react-draft-wysiwyg'
import { EditorState, convertToRaw } from 'draft-js'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import Select from '../../../components/Template/Input/Select'
import DataTable from '../../../components/Template/Table/DataTable'
import DualHorizontalScroll from '../../../components/Template/Table/DualHorizontalScroll'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { getContracts } from '../../../store/ducks/comercial'
import { getLegalSolicitations, postLegalSolicitation, updateStatus, getLegalSolicitationResponses, postLegalSolicitationResponse, getOfficialLettersCreated, getOfficialLettersReceived } from '../../../store/ducks/management'
import oikosApi from '../../../services/oikos'
import { getOikosFileUrl } from '../../../utils/linksOikos/link'

const subjectOptions = [
  { label: 'Análise de Contrato', value: 'Análise de Contrato' },
  { label: 'Elaboração de Contrato', value: 'Elaboração de Contrato' },
  { label: 'Parecer Jurídico', value: 'Parecer Jurídico' },
  { label: 'Consultoria Jurídica', value: 'Consultoria Jurídica' },
  { label: 'Dúvida', value: 'Dúvida' },
  { label: 'Outros', value: 'Outros' },
]

const priorities = [
  { label: 'Urgente', value: 'Urgente' },
  { label: 'Importante', value: 'Importante' },
  { label: 'Sugestão', value: 'Sugestão' },
]

const statusOptions = [
  { label: 'Aguardando atendimento', value: 'Aguardando atendimento' },
  { label: 'Em análise pelo jurídico', value: 'Em análise pelo jurídico' },
  { label: 'Concluído', value: 'Concluído' },
]

const rawToHtml = (editorState) => {
  const raw = convertToRaw(editorState.getCurrentContent())
  return raw.blocks.map(block => block.text.trim() ? `<p>${block.text}</p>` : '').join('')
}

const openAnexo = (e, caminho) => {
  e.preventDefault()
  e.stopPropagation()
  const url = getOikosFileUrl(caminho)
  if (url) window.open(url, '_blank', 'noopener,noreferrer')
}

const collectAnexoItems = (anexoColumn, arquivoRows = []) => {
  const items = []
  const seen = new Set()
  const push = (path, label) => {
    if (!path) return
    const key = String(path)
    if (seen.has(key)) return
    seen.add(key)
    items.push({ path: key, label: label || String(path).split('/').pop() })
  }
  push(anexoColumn)
  ;(Array.isArray(arquivoRows) ? arquivoRows : []).forEach((row) => {
    if (row && row.arquivo_caminho) {
      push(row.arquivo_caminho, row.arquivo_desc)
    }
  })
  return items
}

const fetchArquivosByTab = async (arquivo_tabRef, arquivo_tabId) => {
  if (!arquivo_tabId) return []
  try {
    const res = await oikosApi.post('/', {
      action: 'get',
      table: 'arquivo',
      data: { arquivo_tabRef, arquivo_tabId },
    })
    const rows = Array.isArray(res.data) ? res.data : []
    return rows.filter(r => r && (r.arquivo_ativo === undefined || Number(r.arquivo_ativo) !== 0))
  } catch (err) {
    console.error('Erro ao buscar arquivos:', err)
    return []
  }
}

const resolveRequesterFromAuth = (user) => (
  String(user?.pf_nome || user?.pf_nomeExibicao || user?.displayName || '').trim()
)

const resolveRequesterDisplayNameFromAuth = (user) => (
  String(user?.pf_nomeExibicao || user?.pf_nome || user?.displayName || '').trim()
)

class LegalSolicitations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addSolicitationModalIsOpen: false,
      requester: '',
      requesterInputError: '',
      subject: null,
      subjectInputError: '',
      priority: null,
      priorityInputError: '',
      description: EditorState.createEmpty(),
      descriptionInputError: '',
      endDate: '',
      endDateInputError: '',
      contract: null,
      attachment: null,
      fatoGerador: '',
      solicitations: [],

      detailsModalIsOpen: false,
      selectedSolicitation: null,
      responseDescription: EditorState.createEmpty(),
      responseDescriptionError: '',
      responseAttachment: null,
      responseStatus: null,
      solicitationArquivos: [],
      responseArquivosById: {},
    }
  }

  componentDidMount() {
    this.props.getContracts()
    this.props.getLegalSolicitations()
    this.props.getOfficialLettersCreated()
    this.props.getOfficialLettersReceived()
  }

  getOficioNumberBySolicitacao = (solicitacaoId) => {
    if (!solicitacaoId) return null
    const createdList = Array.isArray(this.props.management.officialLettersCreated)
      ? this.props.management.officialLettersCreated
      : []
    const created = createdList.find(o => Number(o.solicitacoes_juridicas_id) === Number(solicitacaoId))
    if (created) {
      return created.numero_oficio || `#${created.oficios_criados_id || created.id}`
    }
    const receivedList = Array.isArray(this.props.management.officialLettersReceived)
      ? this.props.management.officialLettersReceived
      : []
    const received = receivedList.find(o => Number(o.solicitacoes_juridicas_id) === Number(solicitacaoId))
    if (received) {
      const num = received.numero_oficio || `#${received.oficios_recebidos_id || received.id}`
      return `${num} (recebido)`
    }
    return null
  }

  getContractName = (id) => {
    const contracts = this.props.comercial.getContractsData || []
    const c = contracts.find(c => Number(c.contrato_id) === Number(id))
    return c ? `${c.pj_razaosocial || c.pj_nomefanta || 'Sem Nome'} — Nº ${c.contrato_num || id}` : id
  }

  formatStatus = (row) => {
    const handleChange = (e) => {
      const newStatus = e.target.value
      this.props.updateStatus({
        table: 'solicitacoes_juridicas',
        idField: 'solicitacoes_juridicas_id',
        idValue: row.id || row.solicitacoes_juridicas_id,
        status: newStatus,
      })
    }

    const colorMap = {
      'Aguardando atendimento': '#f0ad4e',
      'Em análise pelo jurídico': '#5bc0de',
      'Concluído': '#5cb85c',
    }

    return (
      <select
        value={row.status}
        onChange={handleChange}
        style={{
          border: `2px solid ${colorMap[row.status] || '#ccc'}`,
          borderRadius: 4,
          padding: '2px 6px',
          fontSize: 12,
          color: colorMap[row.status] || '#333',
          fontWeight: 'bold',
          background: '#fff',
          cursor: 'pointer',
          minWidth: 180,
        }}
      >
        {statusOptions.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    )
  }

  toggleModal = () => {
    this.setState(prevState => ({
      addSolicitationModalIsOpen: !prevState.addSolicitationModalIsOpen,
      requester: !prevState.addSolicitationModalIsOpen
        ? resolveRequesterFromAuth(this.props.auth?.user)
        : prevState.requester,
    }))
  }

  handlePostSubmit = () => {
    const { subject, priority, description, endDate, contract, attachment, requester, fatoGerador } = this.state

    if (!subject) this.setState({ subjectInputError: 'Campo obrigatório.' })
    if (!priority) this.setState({ priorityInputError: 'Campo obrigatório.' })
    const descriptionHtml = rawToHtml(description).trim()
    if (!descriptionHtml || descriptionHtml === '<p></p>') this.setState({ descriptionInputError: 'Campo obrigatório.' })
    if (!endDate) this.setState({ endDateInputError: 'Campo obrigatório.' })
    if (!requester.trim()) this.setState({ requesterInputError: 'Campo obrigatório.' })

    if (subject && priority && descriptionHtml && descriptionHtml !== '<p></p>' && endDate && requester.trim()) {
      const newSolicitation = {
        solicitante: requester,
        solicitanteExibicao: resolveRequesterDisplayNameFromAuth(this.props.auth?.user),
        tipo_assunto: subject.value,
        prioridade: priority.value,
        teor: descriptionHtml,
        prazo_atendimento: moment(endDate).format('YYYY-MM-DD'),
        fato_gerador: fatoGerador,
        status: 'Aguardando atendimento',
      }

      if (contract && contract.value) {
        newSolicitation.contrato_id = contract.value
      }

      if (attachment) {
        newSolicitation.anexo = attachment.name
        newSolicitation.anexoFile = attachment
      }
      this.props.postLegalSolicitation(newSolicitation)
      this.setState({
        addSolicitationModalIsOpen: false,
        requester: '',
        subject: null,
        priority: null,
        description: EditorState.createEmpty(),
        endDate: '',
        contract: null,
        attachment: null,
        fatoGerador: '',
      })
    }
  }

  toggleDetailsModal = (solicitation = null) => {
    this.setState(prevState => {
      const isOpen = !prevState.detailsModalIsOpen
      if (isOpen && solicitation) {
        const sid = solicitation.id || solicitation.solicitacoes_juridicas_id
        this.props.getLegalSolicitationResponses(sid)
        this.loadSolicitationArquivos(sid)
        return {
          detailsModalIsOpen: true,
          selectedSolicitation: solicitation,
          responseStatus: statusOptions.find(opt => opt.value === solicitation.status) || null,
          solicitationArquivos: [],
          responseArquivosById: {},
        }
      }
      return {
        detailsModalIsOpen: false,
        selectedSolicitation: null,
        responseDescription: EditorState.createEmpty(),
        responseDescriptionError: '',
        responseAttachment: null,
        responseStatus: null,
        solicitationArquivos: [],
        responseArquivosById: {},
      }
    })
  }

  loadSolicitationArquivos = async (solicitacaoId) => {
    const rows = await fetchArquivosByTab('solicitacoes_juridicas', solicitacaoId)
    this.setState({ solicitationArquivos: rows })
  }

  loadResponseArquivos = async (responses) => {
    const list = Array.isArray(responses) ? responses : []
    const entries = await Promise.all(list.map(async (res) => {
      const rid = res.id || res.solicitacoes_juridicas_respostas_id
      const rows = await fetchArquivosByTab('solicitacoes_juridicas_respostas', rid)
      return [String(rid), rows]
    }))
    const responseArquivosById = {}
    entries.forEach(([id, rows]) => { responseArquivosById[id] = rows })
    this.setState({ responseArquivosById })
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.management?.legalSolicitationResponses
    const curr = this.props.management?.legalSolicitationResponses
    if (this.state.detailsModalIsOpen && curr !== prev && Array.isArray(curr)) {
      this.loadResponseArquivos(curr)
    }
  }

  renderAnexoLinks = (items, { outline = false } = {}) => {
    if (!items || !items.length) return null
    return (
      <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: 6 }}>
        {items.map(item => (
          <a
            key={item.path}
            href={getOikosFileUrl(item.path)}
            onClick={e => openAnexo(e, item.path)}
            target="_blank"
            rel="noreferrer"
            className={outline ? 'btn btn-sm btn-outline-primary' : undefined}
            style={outline ? undefined : { fontSize: '13px' }}
          >
            <i className="ri-attachment-line" /> {item.label || 'Anexo'}
          </a>
        ))}
      </div>
    )
  }

  handleResponseSubmit = () => {
    const { selectedSolicitation, responseDescription, responseAttachment, responseStatus } = this.state
    const { user } = this.props.auth

    const descriptionHtml = rawToHtml(responseDescription).trim()
    if (!descriptionHtml || descriptionHtml === '<p></p>') {
      this.setState({ responseDescriptionError: 'A resposta não pode estar vazia.' })
      return
    }

    const payload = {
      solicitacao_id: selectedSolicitation.id || selectedSolicitation.solicitacoes_juridicas_id,
      teor: descriptionHtml,
      status_alterado_para: responseStatus ? responseStatus.value : null,
      autor_pf_id: user?.pf_id || user?.id || null,
      anexoFile: responseAttachment,
    }

    this.props.postLegalSolicitationResponse(payload)

    // Clear the inputs
    this.setState({
      responseDescription: EditorState.createEmpty(),
      responseDescriptionError: '',
      responseAttachment: null,
    })
  }

  render() {
    const {
      addSolicitationModalIsOpen, subject, subjectInputError,
      priority, priorityInputError,
      description, descriptionInputError, endDate, endDateInputError,
      contract, attachment, fatoGerador, solicitations,
      requester, requesterInputError,
      detailsModalIsOpen, selectedSolicitation,
      responseDescription, responseDescriptionError, responseAttachment, responseStatus,
      solicitationArquivos, responseArquivosById,
    } = this.state

    const { getContractsData, getContractsIsLoading } = this.props.comercial

    const contractOptions = (getContractsData || []).map(c => ({
      value: c.contrato_id,
      label: `${c.pj_razaosocial || c.pj_nomefanta || 'Sem Nome'} — ${c.contrato_num ? `Nº ${c.contrato_num}` : `ID: ${c.contrato_id}`}`,
    }))

    return (
      <div className="page-content">
        <Modal
          centered
          isOpen={addSolicitationModalIsOpen}
          toggle={() => this.toggleModal()}
        >
          <ModalHeader toggle={() => this.toggleModal()}>
            Novo chamado Jurídico
          </ModalHeader>
          <ModalBody>
            <FormGroup style={{ position: 'relative', zIndex: 100002 }}>
              <Label>Tipo</Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={false}
                isSearchable={false}
                placeholder="Tipo"
                value={subject}
                options={subjectOptions || []}
                onChange={subject => {
                  this.setState({
                    subject,
                    subjectInputError: '',
                  })
                }}
              />
              {subjectInputError && <span style={{ color: 'red' }}>{subjectInputError}</span>}
            </FormGroup>
            <FormGroup style={{ position: 'relative', zIndex: 100001 }}>
              <Label>Prioridade</Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={false}
                isSearchable={false}
                placeholder="Prioridade"
                value={priority}
                options={priorities || []}
                onChange={priority => {
                  this.setState({
                    priority,
                    priorityInputError: '',
                  })
                }}
              />
              {priorityInputError && <span style={{ color: 'red' }}>{priorityInputError}</span>}
            </FormGroup>
            <FormGroup>
              <Label>
                Fato Gerador{' '}
                <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span>
              </Label>
              <Input
                type="text"
                placeholder=""
                value={fatoGerador}
                onChange={e => this.setState({ fatoGerador: e.target.value })}
              />
            </FormGroup>
            <FormGroup style={{ position: 'relative', zIndex: 100000 }}>
              <Label>
                Contrato vinculado{' '}
                <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span>
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable
                isSearchable
                placeholder={getContractsIsLoading ? 'Carregando contratos...' : 'Selecione um contrato...'}
                isDisabled={getContractsIsLoading}
                value={contract}
                options={contractOptions}
                onChange={contract => this.setState({ contract })}
              />
            </FormGroup>
            <FormGroup style={{ position: 'relative', zIndex: 99999 }}>
              <Label>Prazo de atendimento desejado</Label>
              <DatePicker
                locale="pt-BR"
                className="form-control"
                selected={endDate}
                minDate={new Date()}
                dateFormat="dd/MM/yyyy"
                onChange={endDate => this.setState({
                  endDate,
                  endDateInputError: '',
                })}
              />
              {endDateInputError && (
                <span style={{ color: 'red' }}>
                  {endDateInputError}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>Teor/Corpo</Label>
              <div style={{
                border: descriptionInputError ? '1px solid red' : '1px solid #ced4da',
                borderRadius: 4,
                minHeight: 150,
                padding: 2,
              }}>
                <Editor
                  editorState={description}
                  onEditorStateChange={editorState => this.setState({
                    description: editorState,
                    descriptionInputError: '',
                  })}
                  toolbar={{
                    options: ['inline', 'list', 'textAlign', 'history'],
                    inline: { options: ['bold', 'italic', 'underline'] },
                  }}
                  editorStyle={{ minHeight: 120, paddingLeft: 8, paddingRight: 8, fontSize: 14 }}
                  localization={{ locale: 'pt' }}
                />
              </div>
              {descriptionInputError && (
                <span style={{ color: 'red', fontSize: 12 }}>
                  {descriptionInputError}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Anexar arquivo{' '}
                <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span>
              </Label>
              <Input
                type="file"
                onChange={e => this.setState({ attachment: e.target.files[0] || null })}
              />
              {attachment && (
                <span style={{ fontSize: 12, color: '#555', marginTop: 4, display: 'block' }}>
                  📎 {attachment.name}
                </span>
              )}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.toggleModal()}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => this.handlePostSubmit()}
            >
              Enviar
            </Button>
          </ModalFooter>
        </Modal>

        {/* MODAL DE DETALHES E RESPOSTAS */}
        <Modal
          centered
          size="lg"
          isOpen={detailsModalIsOpen}
          toggle={() => this.toggleDetailsModal()}
        >
          <ModalHeader toggle={() => this.toggleDetailsModal()}>
            Detalhes da Solicitação #{selectedSolicitation?.id || selectedSolicitation?.solicitacoes_juridicas_id}
          </ModalHeader>
          <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto', backgroundColor: '#f8f9fa' }}>
            {selectedSolicitation && (
              <div style={{ padding: '15px', backgroundColor: '#fff', borderRadius: '8px', marginBottom: '15px', border: '1px solid #e9ecef' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                  <strong><i className="ri-user-line" /> Solicitante: {selectedSolicitation.solicitante}</strong>
                  <span className="text-muted"><i className="ri-calendar-line" /> Data: {moment(selectedSolicitation.data_criacao).format('DD/MM/YYYY HH:mm')}</span>
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <Badge color="secondary" className="mr-2">{selectedSolicitation.tipo_assunto}</Badge>
                  <Badge color={selectedSolicitation.prioridade === 'Urgente' ? 'danger' : 'info'}>{selectedSolicitation.prioridade}</Badge>
                </div>
                {selectedSolicitation.contrato_id && (
                  <div style={{ marginBottom: '10px', fontSize: '13px' }}>
                    <strong>Contrato:</strong> {this.getContractName(selectedSolicitation.contrato_id)}
                  </div>
                )}
                <div style={{ padding: '10px', backgroundColor: '#f1f5f7', borderRadius: '4px', fontSize: '14px' }} dangerouslySetInnerHTML={{ __html: selectedSolicitation.teor }} />
                {(() => {
                  const items = collectAnexoItems(selectedSolicitation.anexo, solicitationArquivos)
                  if (!items.length) return null
                  return (
                    <div style={{ marginTop: '10px' }}>
                      <div style={{ fontSize: 12, color: '#6c757d', marginBottom: 4 }}>Anexo original da solicitação</div>
                      {this.renderAnexoLinks(items, { outline: true })}
                    </div>
                  )
                })()}
              </div>
            )}

            <h5 className="mt-4 mb-3" style={{ fontSize: '15px', fontWeight: 'bold', color: '#495057' }}>Histórico de Respostas</h5>

            {this.props.management.getLegalSolicitationResponsesIsLoading ? (
              <div className="text-center my-4"><div className="spinner-border text-primary" role="status" /></div>
            ) : (
              <div>
                {this.props.management.legalSolicitationResponses?.length > 0 ? (
                  this.props.management.legalSolicitationResponses.map(res => (
                    <div key={res.id || res.solicitacoes_juridicas_respostas_id} style={{ padding: '12px', backgroundColor: '#fff', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e9ecef' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '12px' }}>
                        <strong>{res.autor_pf_id ? `Autor ID: ${res.autor_pf_id}` : 'Jurídico/Sistema'}</strong>
                        <span className="text-muted">{moment(res.data_criacao).format('DD/MM/YYYY HH:mm')}</span>
                      </div>
                      <div style={{ fontSize: '14px', color: '#333' }} dangerouslySetInnerHTML={{ __html: res.teor }} />

                      <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: 6 }}>
                        {res.status_alterado_para && (
                          <Badge color="light" style={{ border: '1px solid #ddd', color: '#555', alignSelf: 'flex-start' }}>
                            Status alterado para: {res.status_alterado_para}
                          </Badge>
                        )}
                        {(() => {
                          const rid = res.id || res.solicitacoes_juridicas_respostas_id
                          const items = collectAnexoItems(res.anexo, responseArquivosById[String(rid)])
                          if (!items.length) return null
                          return (
                            <div>
                              <div style={{ fontSize: 12, color: '#6c757d', marginBottom: 4 }}>Anexos desta resposta</div>
                              {this.renderAnexoLinks(items)}
                            </div>
                          )
                        })()}
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted" style={{ fontSize: '13px' }}>Nenhuma resposta registrada ainda.</p>
                )}
              </div>
            )}

            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e9ecef' }}>
              <h5 style={{ fontSize: '14px', fontWeight: 'bold' }}>Adicionar Resposta / Pedir Informação</h5>

              <FormGroup className="mt-3">
                <Label style={{ fontSize: '13px' }}>Mudar Status para (opcional)</Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable
                  placeholder="Manter status atual..."
                  value={responseStatus}
                  options={statusOptions}
                  onChange={status => this.setState({ responseStatus: status })}
                />
              </FormGroup>

              <FormGroup>
                <Label style={{ fontSize: '13px' }}>Mensagem *</Label>
                <div style={{
                  border: responseDescriptionError ? '1px solid red' : '1px solid #ced4da',
                  borderRadius: 4,
                  minHeight: 100,
                  padding: 2,
                }}>
                  <Editor
                    editorState={responseDescription}
                    onEditorStateChange={editorState => this.setState({
                      responseDescription: editorState,
                      responseDescriptionError: '',
                    })}
                    toolbar={{
                      options: ['inline', 'list'],
                      inline: { options: ['bold', 'italic'] },
                    }}
                    editorStyle={{ minHeight: 80, paddingLeft: 8, paddingRight: 8, fontSize: 13 }}
                    localization={{ locale: 'pt' }}
                  />
                </div>
                {responseDescriptionError && <span style={{ color: 'red', fontSize: 12 }}>{responseDescriptionError}</span>}
              </FormGroup>

              <FormGroup>
                <Label style={{ fontSize: '13px' }}>
                  Anexar arquivo{' '}
                  <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span>
                </Label>
                <Input
                  type="file"
                  onChange={e => this.setState({ responseAttachment: e.target.files[0] || null })}
                />
                {responseAttachment && (
                  <div style={{ marginTop: 6, fontSize: 13 }}>
                    📎 {responseAttachment.name}
                  </div>
                )}
              </FormGroup>

              <div className="text-right mt-3">
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => this.handleResponseSubmit()}
                  disabled={this.props.management.postLegalSolicitationResponseIsLoading}
                >
                  {this.props.management.postLegalSolicitationResponseIsLoading ? 'Enviando...' : 'Enviar Resposta'}
                </Button>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.toggleDetailsModal()}
              color="light"
              className="waves-effect"
            >
              Fechar
            </Button>
          </ModalFooter>
        </Modal>

        <Container fluid>
          <Breadcrumbs
            title="Solicitação Jurídica"
            breadcrumbItems={[]}
          />

          <Row>
            <Col>
              <h4>Lista</h4>
            </Col>
            <Col style={{ textAlign: 'right' }}>
              <Button
                color="primary"
                type="button"
                onClick={() => this.toggleModal()}
              >
                Novo chamado
              </Button>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Card>
                <CardBody>
                  <DualHorizontalScroll>
                    <DataTable
                      responsive={false}
                      data={{
                      columns: [
                        { label: 'ID', field: 'id' },
                        { label: 'Solicitante', field: 'requester', sort: 'disabled' },
                        { label: 'Data de solicitação', field: 'createDt', sort: 'disabled' },
                        { label: 'Prazo desejado', field: 'endDt', sort: 'disabled' },
                        { label: 'Tipo', field: 'subject', sort: 'disabled' },
                        { label: 'Prioridade', field: 'priority', sort: 'disabled' },
                        { label: 'Contrato', field: 'contract', sort: 'disabled' },
                        { label: 'Ofício vinculado', field: 'oficio', sort: 'disabled' },
                        { label: 'Teor/Corpo', field: 'description', sort: 'disabled', searchable: false },
                        { label: 'Status', field: 'status', sort: 'disabled', searchable: false },
                        { label: 'Anexo', field: 'attachment', sort: 'disabled', searchable: false },
                        { label: 'Ações', field: 'actions', sort: 'disabled', searchable: false },
                      ],
                      rows: (Array.isArray(this.props.management.legalSolicitations) ? [...this.props.management.legalSolicitations] : [])
                        .sort((a, b) => Number(b.id || b.solicitacoes_juridicas_id) - Number(a.id || a.solicitacoes_juridicas_id))
                        .map(row => ({
                        id: row.id || row.solicitacoes_juridicas_id,
                        requester: row.solicitante || '—',
                        createDt: row.data_criacao ? moment(row.data_criacao).format('DD/MM/YYYY') : '—',
                        endDt: row.prazo_atendimento ? moment(row.prazo_atendimento).format('DD/MM/YYYY') : '—',
                        subject: row.tipo_assunto,
                        priority: row.prioridade,
                        contract: row.contrato_id ? this.getContractName(row.contrato_id) : '—',
                        oficio: this.getOficioNumberBySolicitacao(row.id || row.solicitacoes_juridicas_id) || '—',
                        description: <div dangerouslySetInnerHTML={{ __html: row.teor }} />,
                        attachment: row.anexo ? (
                          <a
                            href={getOikosFileUrl(row.anexo)}
                            onClick={e => openAnexo(e, row.anexo)}
                            target="_blank"
                            rel="noreferrer"
                            title="Ver anexo"
                          >
                            <i className="ri-attachment-line" style={{ fontSize: '18px', color: '#556ee6' }} />
                          </a>
                        ) : '—',
                        status: this.formatStatus(row),
                        actions: (
                          <Button color="info" size="sm" onClick={() => this.toggleDetailsModal(row)} title="Ver Detalhes / Responder">
                            <i className="ri-search-line" /> Detalhes
                          </Button>
                        ),
                      })),
                    }}
                    />
                  </DualHorizontalScroll>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ comercial: state.comercial, management: state.management, auth: state.auth })
const mapDispatchToProps = dispatch => bindActionCreators({ getContracts, getLegalSolicitations, postLegalSolicitation, updateStatus, getLegalSolicitationResponses, postLegalSolicitationResponse, getOfficialLettersCreated, getOfficialLettersReceived }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(LegalSolicitations)
